import Choices from 'choices.js'

import 'choices.js/public/assets/styles/choices.css'

const postalCodesElement = document.querySelector('#postalCodes')
if (postalCodesElement) {
    const choices = new Choices(postalCodesElement, {
        searchEnabled: true,
        removeItemButton: true,
        itemSelectText: '',
        placeholderValue: postalCodesElement.dataset.customPlaceholder,
        searchResultLimit: -1,
        searchFields: ['label'],
        fuseOptions: {
            threshold: 0,
            ignoreLocation: true
        },
        position: 'bottom'
    })
}

const areasElement = document.querySelector('#areas')
if (areasElement) {
    const choices = new Choices(areasElement, {
        searchEnabled: true,
        removeItemButton: true,
        itemSelectText: '',
        placeholderValue: areasElement.dataset.customPlaceholder,
        searchResultLimit: 50,
        position: 'bottom'
    })
}

const bedroomsElement = document.querySelector('#bedrooms')
if (bedroomsElement) {
    const choices = new Choices(bedroomsElement, {
        searchEnabled: false,
        itemSelectText: '',
        removeItemButton: true,
        searchResultLimit: 50,
        shouldSort: false,
        position: 'bottom'
    })
}

const typesElement = document.querySelector('#type')
if (typesElement) {
    const choicesTypes = new Choices(typesElement, {
        searchEnabled: false,
        itemSelectText: '',
        removeItemButton: true,
        searchResultLimit: 50,
        position: 'bottom'
    })
}

const priceElement = document.querySelector('#price')
if (priceElement) {
    const choicesTypes = new Choices(priceElement, {
        searchEnabled: false,
        itemSelectText: '',
        removeItemButton: true,
        shouldSort: false,
        searchResultLimit: 50,
        position: 'bottom'
    })
}

const sortElement = document.querySelector('#sort')
if (sortElement) {
    const choicesTypes = new Choices(sortElement, {
        searchEnabled: false,
        itemSelectText: '',
        removeItemButton: false,
        shouldSort: false,
        searchResultLimit: 50,
        position: 'bottom'
    })
}

// if (window.htmx !== undefined) {
//     htmx.on('htmx:afterRequest', function (event) {
//         const postalCodesElement = document.querySelector('#postalCodes')
//         if (postalCodesElement) {
//             const choices = new Choices(postalCodesElement, {
//                 removeItemButton: true
//             })
//         }
//     })

//     htmx.on('htmx:afterRequest', function (event) {
//         const typesElement = document.querySelector('#type')
//         if (typesElement) {
//             const choicesTypes = new Choices(typesElement, {
//                 searchEnabled: false
//             })
//         }
//     })
// }

// import { multipleSelect } from 'multiple-select-vanilla'
// import 'multiple-select-vanilla/dist/styles/css/multiple-select.css'

// const typeMs = multipleSelect('#type', {
//     onClick: () => {
//         // elmMount.classList.add('is-dirty')
//     },
//     onClose: (reason) => {
//         window.dispatchEvent(new CustomEvent('updateResults'))
//     }
// })

// const postalCodes = multipleSelect('#postalCodes', {
//     filter: true,
//     showClear: true,
//     text
//     onClick: () => {
//         // elmMount.classList.add('is-dirty')
//     },
//     onClose: (reason) => {
//         window.dispatchEvent(new CustomEvent('updateResults'))
//     }
// })
